import { useStore } from '@/core/store';

export default function useBookingUtilities (locationId) {
  const store = useStore();

  function tierPriceToLocationPrice (tierPrice) {
    return store.getters.tierPriceToLocationPrice({ locationId, tierPrice });
  }
  return {
    tierPriceToLocationPrice,
  };
}
